import { Box, Button, Typography } from "@mui/material"
import LandingTop from "./LandingTop"
import LandingReason from "./LandingReason"
import LandingKibou from "./LandingKibou"
import LandingFAQ from "./LandingFAQ"
import LandingSteps from "./LandingSteps"
import { NavLink } from "react-router-dom"

export default function Landingpage() {
  return (
    <>
      <LandingTop />

      <Box
        sx={{ mx: { sm: "1em", md: "2em", lg: "6em", xl: "11em" }, mb: "5em" }}
      >
        <LandingKibou />
        <LandingReason />
        <Box sx={{ display: "flex", justifyContent: "center", mt: "4em" }}>
          <Button
            component={NavLink}
            to="/inquiry"
            color="primary"
            variant="contained"
            sx={{ borderRadius: 28, px: "6em" }}
          >
            <Typography variant="body1" color="white">
              ご登録・お問い合わせはこちら
            </Typography>
          </Button>
        </Box>
        <LandingSteps />
        <LandingFAQ />
      </Box>
    </>
  )
}
